module.exports = __webpack_public_path__ + "img/menu02.9ad570dd.jpg";